module.exports = "/images/icon-24-9bc93747f9bd54f0d9b4d590884af842.png";